import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const AssignGradeAutoFunctions = () => {
  const theme = useTheme();

  const smDown = useResponsive('down', 'sm');
  const mdDown = useResponsive('down', 'md');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <Stack spacing={10}>
      <Stack alignItems="center" justifyContent="center" spacing={5}>
        <Typography align="center" variant="h2">
          Giao bài linh hoạt
        </Typography>
        <Grid container maxWidth={1240} justifySelf="center" spacing={4}>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.94' : '',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  <Typography variant="h5">Giao bài theo lớp, nhóm hoặc từng học viên</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tùy chọn linh hoạt để giao bài tập phù hợp với từng lớp học, nhóm học sinh yếu,
                    hoặc cá nhân cụ thể.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="gradientbg4"
                    src="/assets/sub-pages/gradient4.png"
                    zIndex={1}
                    bottom={0}
                    left={30}
                    width="95%"
                    height={smDown ? '70%' : '88%'}
                    position="absolute"
                    sx={{ opacity: 0.2 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/lms/assign-grade-auto/assign.png"
                    zIndex={2}
                    width={1}
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.94' : '',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  {' '}
                  <Typography variant="h5">Cài đặt thời gian làm bài và thời hạn nộp</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Thiết lập khung giờ mở bài – đóng bài, giới hạn thời lượng làm bài như một kỳ
                    thi thực tế.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="gradientbg8"
                    src="/assets/sub-pages/gradient8.png"
                    zIndex={1}
                    top={smDown ? 30 : -15}
                    left={-20}
                    height="95%"
                    position="absolute"
                    sx={{ opacity: 0.3 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg9"
                    src="/assets/sub-pages/gradient9.png"
                    zIndex={1}
                    position="absolute"
                    top={smDown ? 30 : -15}
                    height="90%"
                    right={-100}
                    sx={{ opacity: 0.3 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    alignSelf="end"
                    alt="class-dashboard"
                    component="img"
                    width={0.95}
                    src="/assets/sub-pages/lms/assign-grade-auto/setting.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.94' : '',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  <Typography variant="h5">Giới hạn số lần làm bài và điểm tối thiểu</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Giúp kiểm soát tiến độ học tập, tăng tính nghiêm túc và thúc đẩy học sinh làm
                    bài cẩn thận hơn.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="gradientbg4"
                    src="/assets/sub-pages/gradient4.png"
                    zIndex={1}
                    bottom={0}
                    left={30}
                    width="95%"
                    height={smDown ? '70%' : '88%'}
                    position="absolute"
                    sx={{ opacity: 0.2 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/lms/assign-grade-auto/limit.png"
                    zIndex={2}
                    width={0.95}
                    alignSelf="end"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.94' : '',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  {' '}
                  <Typography variant="h5">Tất cả hình thức bài tập & thi cử</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Phù hợp với tất cả hình thức bài tập & đề thi: Làm bài tại lớp - làm bài trực
                    tuyến hoặc tự làm bài ôn tập tại nhà.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="gradientbg8"
                    src="/assets/sub-pages/gradient8.png"
                    zIndex={1}
                    top={smDown ? 30 : -15}
                    left={-20}
                    height="95%"
                    position="absolute"
                    sx={{ opacity: 0.3 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg9"
                    src="/assets/sub-pages/gradient9.png"
                    zIndex={1}
                    position="absolute"
                    top={smDown ? 30 : -15}
                    height="90%"
                    right={-100}
                    sx={{ opacity: 0.3 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    alignSelf="center"
                    alt="class-dashboard"
                    component="img"
                    width={1}
                    src="/assets/sub-pages/lms/assign-grade-auto/multiple-format.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.95' : '',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  <Typography variant="h5">Giao bài từ kho bài tập hoặc tạo mới nhanh</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Giao ngay từ ngân hàng câu hỏi được biên soạn từ các bộ giáo trình nổi tiếng
                    nhất hoặc từ bộ câu hỏi riêng của Trung tâm
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    src="/assets/sub-pages/gradient10.png"
                    alt="gradientbg10"
                    zIndex={1}
                    bottom={-50}
                    left={-20}
                    height="92%"
                    position="absolute"
                    sx={{ opacity: 0.2 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg11"
                    src="/assets/sub-pages/gradient11.png"
                    zIndex={1}
                    position="absolute"
                    bottom={-40}
                    height="88%"
                    right={-100}
                    sx={{ opacity: 0.2 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-task"
                    src="/assets/sub-pages/lms/assign-grade-auto/assignment-bank.png"
                    zIndex={2}
                    width={1}
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.95' : '',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  {' '}
                  <Typography variant="h5">Thông báo tự động đến học sinh</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Học sinh nhận thông báo qua tài khoản, email hoặc app mobile giúp đảm bảo không
                    bỏ sót bài tập
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    src="/assets/sub-pages/gradient10.png"
                    alt="gradientbg10"
                    zIndex={1}
                    bottom={-50}
                    left={-20}
                    height="92%"
                    position="absolute"
                    sx={{ opacity: 0.2 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg11"
                    src="/assets/sub-pages/gradient11.png"
                    zIndex={1}
                    position="absolute"
                    bottom={-40}
                    height="88%"
                    right={-100}
                    sx={{ opacity: 0.2 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/lms/assign-grade-auto/notification.png"
                    zIndex={2}
                    width={0.95}
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
      <Stack alignItems="center" justifyContent="center" spacing={5}>
        <Typography align="center" variant="h2">
          Chấm bài tự động với AI
        </Typography>{' '}
        <Grid container maxWidth={1240} justifySelf="center" spacing={4}>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.94' : '',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  <Typography variant="h5">Chấm điểm tự động với AI</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Kết quả có ngay sau khi nộp bài với hệ thống tính điểm chính xác, linh hoạt theo
                    từng câu hỏi.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    src="/assets/sub-pages/gradient10.png"
                    alt="gradientbg10"
                    zIndex={1}
                    bottom={-50}
                    left={-20}
                    height="92%"
                    position="absolute"
                    sx={{ opacity: 0.2 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg11"
                    src="/assets/sub-pages/gradient11.png"
                    zIndex={1}
                    position="absolute"
                    bottom={-40}
                    height="88%"
                    right={-100}
                    sx={{ opacity: 0.2 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/lms/assign-grade-auto/grade-ai.png"
                    zIndex={2}
                    width={0.95}
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.94' : '',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  {' '}
                  <Typography variant="h5">Kết quả được tự động cập nhật và đồng bộ</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Điểm và nhận xét được tự động ghi nhận và đồng bộ vào hồ sơ học tập học sinh -
                    báo cáo học tập - sổ liên lạc điện tử
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="gradientbg8"
                    src="/assets/sub-pages/gradient8.png"
                    zIndex={1}
                    top={smDown ? 30 : -15}
                    left={-20}
                    height="95%"
                    position="absolute"
                    sx={{ opacity: 0.3 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg9"
                    src="/assets/sub-pages/gradient9.png"
                    zIndex={1}
                    position="absolute"
                    top={smDown ? 30 : -15}
                    height="90%"
                    right={-100}
                    sx={{ opacity: 0.3 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    alignSelf="center"
                    alt="class-dashboard"
                    component="img"
                    width={1}
                    src="/assets/sub-pages/lms/assign-grade-auto/sync.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.94' : '',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  <Typography variant="h5">Giáo viên nhận xét và trao đổi với học viên</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Giáo viên có thể viết nhận xét riêng cho từng câu hỏi, bài làm và học viên.
                    Tương tác trao đổi với học viên về kết quả và những điểm cần chú ý.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    src="/assets/sub-pages/gradient10.png"
                    alt="gradientbg10"
                    zIndex={1}
                    bottom={-50}
                    left={-20}
                    height="92%"
                    position="absolute"
                    sx={{ opacity: 0.2 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg11"
                    src="/assets/sub-pages/gradient11.png"
                    zIndex={1}
                    position="absolute"
                    bottom={-40}
                    height="88%"
                    right={-100}
                    sx={{ opacity: 0.2 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/lms/assign-grade-auto/feedback.png"
                    zIndex={2}
                    width={0.95}
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                maxWidth: 820,
                width: '100%',
                justifySelf: 'center',
                aspectRatio: !mdDown ? '1 / 0.94' : '',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack justifyContent="space-between" height="100%">
                <Stack p={padding} zIndex={2}>
                  {' '}
                  <Typography variant="h5">Báo cáo bài làm chi tiết và rõ ràng</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Báo cáo theo lớp, từng học viên, theo từng bài tập/đề thi – dễ dàng đánh giá
                    chất lượng học tập và cải thiện giảng dạy.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="gradientbg8"
                    src="/assets/sub-pages/gradient8.png"
                    zIndex={1}
                    top={smDown ? 30 : -15}
                    left={-20}
                    height="95%"
                    position="absolute"
                    sx={{ opacity: 0.3 }}
                  />
                  <Box
                    component="img"
                    alt="gradientbg9"
                    src="/assets/sub-pages/gradient9.png"
                    zIndex={1}
                    position="absolute"
                    top={smDown ? 30 : -15}
                    height="90%"
                    right={-100}
                    sx={{ opacity: 0.3 }}
                  />
                </Stack>
                <Stack>
                  <Box
                    alignSelf="center"
                    alt="class-dashboard"
                    component="img"
                    width={1}
                    src="/assets/sub-pages/lms/assign-grade-auto/report.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
